import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import Loader from '../Loader/Loader'
import { ChangeEvent } from 'react'

type Props = {
	isCreateOpen: boolean
	toggleCreateCompanyDialog: () => void
	handleCreateCompany: () => void
	loading: boolean
	setNewCompanyName: (name: string) => void
	newCompanyName: string
}

const CreateCompanyDialog = ({
	isCreateOpen,
	toggleCreateCompanyDialog,
	handleCreateCompany,
	loading,
	setNewCompanyName,
	newCompanyName,
}: Props) => {
	const isCreateDisabled = !newCompanyName || newCompanyName.trim() === ''

	const handleNewCompanyNameChange = (e: ChangeEvent<HTMLInputElement>) => {
		setNewCompanyName(e.target.value)
	}

	return (
		<Dialog open={isCreateOpen} onOpenChange={toggleCreateCompanyDialog}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Add workspace</DialogTitle>
					<DialogDescription>Add new workspace to Hit Em Up</DialogDescription>
				</DialogHeader>
				<div className="my-2">
					<input
						className="w-full border-2 rounded-full px-6 py-4 mt-2"
						type="text"
						placeholder="Workspace name"
						value={newCompanyName}
						onChange={handleNewCompanyNameChange}
					/>
				</div>
				<DialogFooter className="sm:justify-center gap-2">
					{loading ? (
						<Loader />
					) : (
						<>
							<Button onClick={() => handleCreateCompany()} disabled={isCreateDisabled}>
								Create workspace
							</Button>
							<Button variant={'outline'} onClick={toggleCreateCompanyDialog}>
								Cancel
							</Button>
						</>
					)}
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}

export default CreateCompanyDialog
